'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCloudStorage = function TiCloudStorage(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 15c-0.2 0-0.4 0-0.6 0-1.3-3.9-5.1-6.7-9.4-6.7-5.5 0-10 4.5-10 10 0 0.1 0 0.2 0 0.2-2.8 0.8-5 3.4-5 6.5 0 3.7 3 6.7 6.7 6.7h8.3v-7.7l-2.1 2.2c-0.3 0.3-0.8 0.5-1.2 0.5s-0.9-0.2-1.2-0.5c-0.6-0.7-0.6-1.7 0-2.4l5-5c0.2-0.1 0.4-0.3 0.6-0.3 0.4-0.2 0.8-0.2 1.2 0 0.2 0 0.4 0.2 0.6 0.3l5 5c0.6 0.7 0.6 1.7 0 2.4-0.3 0.3-0.8 0.5-1.2 0.5s-0.9-0.2-1.2-0.5l-2.1-2.2v7.7h6.6c4.6 0 8.4-3.8 8.4-8.4s-3.8-8.3-8.4-8.3z' })
        )
    );
};

exports.default = TiCloudStorage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/cloud-storage.js
// module id = 2017
// module chunks = 0